import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from '../../custom-hooks/useAppSelector';
import { getUserAppLoginStatus } from './flipdishAppBanner.service';

/**
 * Whether the Flipdish mobile-app download banner should be visible.
 * Matches FlipdishAppBanner: hide for staff and for users who already log into
 * the app; fail open on loading/errors (only a confirmed positive hides it).
 */
export const useShouldShowFlipdishAppBanner = (): boolean => {
  const email = useAppSelector((state) => state.account?.Email);
  const isFlipdishStaff = Boolean(email && email.toLowerCase().endsWith('@flipdish.com'));

  const { data: appLoginStatus } = useQuery({
    queryKey: ['flipdishAppLoginStatus', email],
    queryFn: getUserAppLoginStatus,
    enabled: Boolean(email) && !isFlipdishStaff,
    retry: 1,
    staleTime: 1000 * 60 * 10,
  });

  if (isFlipdishStaff) {
    return false;
  }

  if (appLoginStatus?.hasLoggedIn) {
    return false;
  }

  return true;
};
